import { observer } from "mobx-react-lite";
import type React from "react";
import { useRef } from "react";
import type { TextInput } from "react-native-gesture-handler";
import { XStack } from "tamagui";
import { Input } from "../../../../ui/InputNew";
import { Label } from "../../../../ui/Label";
import type { ExpenseFormState } from "./ExpenseFormState";

export const AddExpenseFormTitle: React.FC<{
  formState: ExpenseFormState;
}> = observer(({ formState }) => {
  const inputRef = useRef<TextInput>(null);

  return (
    <XStack
      onPress={() => inputRef.current?.focus()}
      padding="$large"
      backgroundColor={"$backgroundBlock"}
      gap={"$medium"}
      alignItems="center"
    >
      <Label>Reason</Label>
      <Input
        placeholder="Hotel, flights, venue, food..."
        ref={inputRef}
        defaultValue={formState.title}
        onChangeText={(text) => formState.setTitle(text)}
      />
    </XStack>
  );
});
